<template>
  <div class="mc-alert-center-detail-wrapper">
    <section class="mc-alert-center-detail">
      <template v-if="isSectionNewMediaActive && !!detailNotification">
        <DetailNotificationMedia />
      </template>
      <div class="mc-alert-center-detail__nomedia mc-alert-center-detail__info-wrapper">
        <div class="mc-alert-center-detail__info">
          <b-row class="mc-alert-center-detail__info-row">
            <b-col :lg="isSectionNewMediaActive ? 6 : 12">
              <b-card class="mc-alert-center-detail__info-card">
                <h4 class="mc-alert-center-detail__info-timeline-title">
                  {{ $t('notification.text.lastEventInfo') }}
                </h4>
                <div class="mc-alert-center-detail__wrapper-info">
                  <div class="mc-alert-center-detail__info-vehicle">
                    <img
                      :src="require('@/assets/images/onboarding/icon/Logistic.png')"
                      alt="Truck Icon"
                    />
                    <div>
                      <h6 class="mb-0">
                        {{ alert.vehicle.licensePlate }}
                      </h6>
                      <McChipList
                        v-if="alert.vehicle?.vehicle2Vgroup?.length"
                        class="notification__vechile-group-items py-2"
                        :data-me="`notification__vechile-group-items-${alert?.rawAlertId}`"
                        :items="getSortedVgroupItems(alert.vehicle?.vehicle2Vgroup)"
                        :maxVisible="5"
                        itemTextField="name"
                        :hideToggle="true"
                        :truncateTextLength="19"
                        variant="outline-secondary"
                      />

                      <div class="d-flex gap-2 notification__driver-info">
                        <i
                          class="icon-fill_driver-2 text-muted"
                          style="font-size: 24px; line-height: 1"
                        ></i>
                        <p class="text-muted">
                          {{ alert.driver?.fullname ?? '-' }} ({{
                            !alert.driver?.phoneNo || alert.driver?.phoneNo == ''
                              ? '-'
                              : alert.driver?.phoneNo
                          }})
                        </p>
                      </div>
                    </div>
                  </div>
                  <b-row class="mt-2">
                    <b-col md="12" class="mc-alert-center-detail__info-location">
                      <i class="mc-fa icon-fill_pin font-size-20"></i>
                      <div>
                        <span class="text-muted">
                          {{ $t('notification.text.locationEvent') }}
                        </span>
                        <p>{{ alert?.address ?? '-' }}</p>
                      </div>
                    </b-col>
                    <b-col md="12">
                      <AlertData
                        :alert="alert"
                        :maxVisibleGeofence="3"
                        class="mc-alert-detail__alert-data"
                      />
                    </b-col>
                  </b-row>

                  <div class="mc-alert-center-detail__info-false">
                    <div v-if="isResolved" class="d-flex justify-content-between">
                      <div class="mc-alert-center-detail_info-false_icon">
                        <i
                          v-if="isFalseAlert"
                          class="mc-icon mc-icon__red icon-fill_bell-off red"
                        ></i>
                        <i
                          v-else
                          class="mc-icon mc-icon__green icon-fill_checkmark-circle green"
                        ></i>
                        {{ $t('notification.action.notificationChecked') }}
                      </div>

                      <div class="mc-alert-center-detail_info-false_link">
                        <a @click="openModalRecheck"> {{ $t('notification.action.recheck') }} </a>
                      </div>
                    </div>

                    <div v-else-if="falseAlarm">
                      <FormulateForm ref="formRef">
                        <FormulateInput
                          v-model="falseAlertNotes"
                          name="falseAlertNotes"
                          :placeholder="$t('notification.action.fillResolveNote')"
                          validation="required"
                          error-behavior="live"
                          validation-behavior="live"
                        >
                          <template #label>
                            <div class="d-flex justify-content-between align-items-center">
                              <label>
                                {{ $t('notification.action.consideredFalseAlert') }}
                                <i class="text-danger">*</i>
                              </label>
                            </div>
                          </template>
                        </FormulateInput>

                        <McButton
                          :text="$t('notification.text.notValid')"
                          size="sm"
                          class="ms-1"
                          variant="info"
                          @click="falseAlertNotes = $t('notification.text.notValid')"
                        />
                        <McButton
                          :text="$t('notification.text.otherIncident')"
                          size="sm"
                          class="ms-1"
                          variant="info"
                          @click="falseAlertNotes = $t('notification.text.otherIncident')"
                        />

                        <b-row class="mc-alert-center-detail__info-note__button-confirm">
                          <b-col md="6" class="px-1">
                            <b-button block variant="outline-primary" @click="handleCancelQuestion">
                              {{ $t('global.cancel') }}
                            </b-button>
                          </b-col>
                          <b-col md="6" class="px-1">
                            <b-button
                              type="submit"
                              block
                              variant="primary"
                              @click="openModalConfirmation"
                            >
                              {{ $t('global.save') }}
                            </b-button>
                          </b-col>
                        </b-row>
                      </FormulateForm>
                    </div>
                    <div v-else-if="isQuestioning" class="d-flex justify-content-between">
                      <div>{{ $t('notification.action.alreadyCheck') }}</div>
                      <div>
                        <b-tooltip
                          v-if="!alert.isImportant && !alert.isUrgent"
                          target="resolve-btn"
                          placement="top"
                        >
                          {{ $t('notification.text.onlyForImportantAlert') }}
                        </b-tooltip>
                        <McButton
                          id="resolve-btn"
                          :text="$t('global.yes')"
                          variant="secondary-success"
                          size="sm"
                          icon="icon-outline_checkmark-circle"
                          class="me-2"
                          :disabled="!alert.isImportant && !alert.isUrgent"
                          @click="changeResolved"
                        />
                        <McButton
                          size="sm"
                          :text="$t('notification.action.falseNotification')"
                          icon="icon-outline_bell-off"
                          variant="secondary-red"
                          @click="isFalseAlarm"
                        />
                      </div>
                    </div>
                  </div>

                  <b-col lg="12" class="mt-2">
                    <b-card class="mc-alert-center-detail__info-card">
                      <h5 class="mc-alert-center-detail__info-comment-title">
                        {{ $t('notification.text.noteAndComment') }}
                      </h5>
                      <div class="mc-alert-center-detail__info-note">
                        <FormulateInput
                          v-model="noteForm"
                          type="textarea"
                          name="note"
                          :placeholder="$t('notification.text.giveNoteOrComment')"
                          validation="max:300,length"
                          error-behavior="live"
                          validation-behavior="live"
                        />

                        <McButton
                          :text="''"
                          icon="icon-outline_paper-plane"
                          variant="secondary"
                          @click="addComment"
                        />
                      </div>
                      <div
                        v-if="Object.keys(userLogs).length > 0"
                        class="mc-alert-center-detail__info-logs"
                      >
                        <div
                          v-for="(logs, date) in userLogs"
                          :key="date"
                          class="user-logs__wrapper"
                        >
                          <div class="user-logs__item mb-2">
                            <span>{{ date }}</span>
                          </div>
                          <div v-for="(log, index) in logs" :key="index" class="user-logs__item">
                            <div class="user-logs-content">
                              <i class="mc-fa icon-fill_checkmark-circle"></i>
                              <span class="user-logs-user me-1"
                                ><strong>{{ log.user.fullname }}</strong></span
                              >
                              <div>
                                <template v-if="log.typeField === 'Resolve'">
                                  <span>
                                    {{ $t('notification.text.markAs').toLowerCase() }}
                                  </span>
                                  <span
                                    :class="log.data === 'true' ? 'text-success' : 'text-danger'"
                                  >
                                    {{ log.data === 'true' ? 'Resolved' : 'Unresolved' }}
                                  </span>
                                </template>
                                <template v-else-if="log.typeField === 'FalseAlert'">
                                  <span v-if="log.data.includes('true')">
                                    {{ $t('notification.text.markAs').toLowerCase() }}
                                    <span class="text-danger">False Alert</span>
                                    <template v-if="log.data.includes('|')">
                                      {{
                                        `, ${$t('notification.text.reasons')} ${
                                          log.data.split('|')[1]
                                        }`
                                      }}
                                    </template>
                                  </span>
                                  <span v-else>
                                    {{ $t('notification.text.canceled') }}
                                    <span class="text-danger">False Alert</span>
                                  </span>
                                </template>
                                <template v-else-if="log.typeField === 'Feedback'">
                                  <span>
                                    {{ `${log.data}` }}
                                  </span>
                                </template>
                                <template v-else>
                                  <span v-if="log.data === 'true'">
                                    {{ $t('notification.text.markAs').toLowerCase() }}
                                    <span class="text-danger">False Alert</span>
                                  </span>
                                  <span v-else>
                                    {{ $t('notification.text.markAs').toLowerCase() }}
                                    <span class="text-danger">Unresolved</span>
                                  </span>
                                </template>
                              </div>
                            </div>
                            <div class="user-logs-time">
                              <span>
                                {{ momentTime(log.createdOn) }}
                              </span>
                              {{ getLabelTimezone() }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card>
                  </b-col>
                </div>
              </b-card>
            </b-col>

            <b-col v-if="alert.alertCode == 151" lg="12">
              <b-card class="mc-alert-center-detail__info-card">
                <div class="d-flex justify-content-between">
                  <h4 class="mc-alert-center-detail__info-timeline-title">
                    {{ $t('notification.text.affectedDO') }} <span>({{ doTotalCount }})</span>
                  </h4>
                  <div class="d-flex align-items-center">
                    <span>{{ $t('notification.text.temperatureDetected') }}</span>
                    <McAlert
                      variant="error"
                      class="alert-error"
                      :text="`${alert.alertData.split('|')[4]?.trim().replace(/\.0$/, '')} °C`"
                    />
                  </div>
                </div>
                <div>
                  <TableDO :alertData="alertData" @do-count="doTotalCount = $event" />
                </div>
              </b-card>
            </b-col>

            <b-col :lg="isSectionNewMediaActive ? 6 : 12">
              <b-card class="mc-alert-center-detail__info-card">
                <h4 class="mc-alert-center-detail__info-timeline-title">
                  {{ $t('notification.text.historyLastHour') }}
                </h4>
                <div
                  :class="
                    hasAccess(['e4e-alert-center-urgent:read'])
                      ? 'timeline'
                      : 'timeline timeline-important'
                  "
                >
                  <div class="timeline__wrapper">
                    <div v-for="(group, date) in groupedAlerts" :key="date" class="timeline__item">
                      <i class="mc-fa icon-outline_arrow-circle-right"></i>
                      <div class="timeline__date">
                        {{ date }}
                      </div>

                      <div
                        v-for="(item, timeIndex) in group"
                        :key="timeIndex"
                        class="timeline__time"
                        @click="selectAlert(item, timeIndex)"
                      >
                        <span class="text-muted">
                          {{ momentTimeSeconds(item.createdOn) }} {{ getLabelTimezone() }}
                        </span>
                        <span
                          class="description text-muted"
                          :class="{
                            icon_urgent: item.isUrgent,
                            icon_important: item.isImportant,
                            icon_grey: !item.isUrgent && !item.isImportant,
                          }"
                        >
                          <img :src="item.alert.iconUrl" class="icon_general" alt="alert-icon" />
                          {{
                            language == 'en' ? item.alert.descriptionEng : item.alert.descriptionIdn
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </div>
    </section>
    <ModalConfirmation @submit="handleSubmitFalseNotes" @submitRecheck="handleResolve(false)" />
  </div>
</template>
<script>
import AlertData from '@/components/ModalAlertMedia/AlertData.vue'
import McButton from '@/components/McButton'
import McChipList from '@/components/McChipList'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import { UPSERT_RAW_ALERTS_ACTION } from '@/services/api/driverscore/score'
import moment from 'moment'
import i18n from '@/i18n'
import ModalConfirmation from './ModalConfirmation.vue'
import DetailNotificationMedia from './media/index.vue'
import { mapGetters } from 'vuex'
import McAlert from '@/components/McAlert'
import TableDO from './TableDO.vue'

moment.locale('id')

export default {
  name: 'AlertDetail',
  components: {
    AlertData,
    McButton,
    ModalConfirmation,
    DetailNotificationMedia,
    McAlert,
    TableDO,
    McChipList,
  },
  mixins: [Helper, MixPanel],
  props: {
    alertData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      language: i18n.locale,
      doTotalCount: 0,
      fieldShow: JSON.parse(localStorage.getItem('generalNotifFields')),
      falseAlertForm: {},
      formOpen: false,
      falseAlertSubmit: true,
      detailNotification: null,
      isEditing: false,
      noteForm: '',
      falseAlertNotes: '',
      isQuestioning: true,
      falseAlarm: false,
      isResolved: false,
      isFalseAlert: false,
      selectionMode: 'Selection',
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),

    alert() {
      return this.alertData
    },

    userLogs() {
      if (!this.alert?.userLogs) return {}

      const groups = {}
      this.alert.userLogs.forEach((log) => {
        const date = this.momentDateShortMonth(log.createdOn)
        if (!groups[date]) {
          groups[date] = []
        }
        groups[date].push(log)
      })

      Object.keys(groups).forEach((date) => {
        groups[date].sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn))
      })

      return groups
    },

    groupedAlerts() {
      const groups = {}
      this.alert.previousAlerts?.forEach((alert) => {
        const date = this.momentDateShortMonth(alert.createdOn)
        if (!groups[date]) {
          groups[date] = []
        }
        groups[date].push(alert)
      })
      return groups
    },

    isSectionNewMediaActive() {
      return (
        this.hasAccess('b3m-trackvision-media-detail-notification:read') &&
        this.isHaveMediaMultiImei
      )
    },

    // case multi imei
    isHaveMediaMultiImei() {
      if (!this.alert) return false
      // case 1 : if there is only 1 device and device is cam in one family
      let isParentCam =
        this.alert.vehicle.sensor?.some((data) => data.sensorCode === 35) &&
        (this.deviceTypeParent === 'jc' ||
          this.deviceTypeParent === 'bsj' ||
          this.deviceTypeParent === 'vss-howen')

      // case 2 : if there is child cam
      // implement in multi imei, if the parent gps have children cam
      const isChildCam = this.alert.vehicle.children?.length || !!this.alert.childVehicleId

      // case 3 : check to field media
      // if media is exist (mean more than 0 item), assume raw alert have media that source is device cam
      const isHaveMedia =
        this.alert.media?.length > 0 ||
        (this.alert.formattedAlertData?.startsWith('https') ?? false)

      return isParentCam || isChildCam || isHaveMedia
    },

    deviceTypeParent() {
      let deviceCode = this.alert.vehicle.device?.deviceCode
      return this.getDeviceType(deviceCode)
    },

    fields() {
      return [
        {
          key: 'do',
          label: this.$t('delivery.fields.deliveryNumber'),
          isRedirectable: true,
          thClass: 'mc-table--170',
        },
        {
          key: 'min',
          label: 'Min. ' + this.$t('notification.field.temperature'),
        },
        {
          key: 'max',
          label: 'Max. ' + this.$t('notification.field.temperature'),
        },
      ]
    },
  },

  watch: {
    '$i18n.locale': function (val) {
      this.language = val
    },
  },

  async mounted() {
    await this.getFeedback()
  },
  beforeDestroy() {
    this.$store.commit('notification/resetDataDvhRequested')
  },
  methods: {
    handleCancelFalseAlert() {
      this.formOpen = false
      this.falseAlertForm = {}
    },

    falseAlertValue(value) {
      if (value == this.$t('notification.text.notValid')) return 'Tidak ada kejadian'
      if (value == this.$t('notification.text.otherIncident')) return 'Kejadian lainnya'
    },

    handleSubmitFalseNotes() {
      this.saveFalseAlert(true)
    },

    async saveFalseAlert(isFalseAlert) {
      try {
        const falseAlertNotes = this.falseAlertNotes ? this.falseAlertNotes : this.noteForm
        let input = {}

        if (isFalseAlert) {
          input = {
            rawAlertId: this.detailNotification?.rawAlertId
              ? [this.detailNotification.rawAlertId]
              : [],
            actionType: 'FalseAlert',
            selectionMode: this.selectionMode,
            data: 'true',
          }

          const falseAlertRes = await this.$apollo.mutate({
            mutation: UPSERT_RAW_ALERTS_ACTION,
            variables: { input },
          })

          if (!falseAlertRes.data.upsertRawAlertsAction.isSuccessful) {
            throw new Error('Failed to set false alert')
          }

          if (falseAlertNotes && falseAlertNotes.trim() !== '') {
            const feedbackInput = {
              rawAlertId: this.detailNotification?.rawAlertId
                ? [this.detailNotification.rawAlertId]
                : [],
              actionType: 'Feedback',
              selectionMode: this.selectionMode,
              data: falseAlertNotes,
            }

            await this.$apollo.mutate({
              mutation: UPSERT_RAW_ALERTS_ACTION,
              variables: { input: feedbackInput },
            })
          }

          this.track('Set as False Alert', {
            location: 'Detail',
            alert_name: this.alert.alert.descriptionIdn,
          })

          this.$nextTick(() => {
            this.isResolved = true
            this.isFalseAlert = isFalseAlert

            this.isQuestioning = false
            this.falseAlarm = false
            this.noteForm = falseAlertNotes

            this.$root.$emit('notification-detail-reload')
          })
          this.$forceUpdate()
        } else {
          const resolveInput = {
            rawAlertId: this.detailNotification?.rawAlertId
              ? [this.detailNotification.rawAlertId]
              : [],
            actionType: 'FalseAlert',
            selectionMode: this.selectionMode,
            data: falseAlertNotes ? `false|${falseAlertNotes}` : 'false',
          }

          await this.$apollo.mutate({
            mutation: UPSERT_RAW_ALERTS_ACTION,
            variables: { input: resolveInput },
          })
          this.$nextTick(() => {
            this.$root.$emit('notification-detail-reload')
          })
        }

        this.$mcToast.success(this.$t('global.alert.text.saved'))
        this.$bvModal.hide('false-alert-confirmation')
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error in saveFalseAlert:', error)
        this.$mcToast.error(this.$t('global.alert.text.failedSaved'))
      }
    },

    getFeedback() {
      this.isResolved = this.alert?.isResolved || false
      this.isFalseAlert = this.alert?.isFalseAlert || false
      if (this.isResolved) {
        this.isQuestioning = false
        this.falseAlarm = false
      } else {
        this.isQuestioning = true
        this.falseAlarm = false
      }

      this.detailNotification = { ...this.alert }
    },

    handleCancel() {
      this.isEditing = false
    },

    handleFalseAlert() {
      this.handleUpsertAlert('FalseAlert')
      this.saveFalseAlert(true)
    },

    changeResolved() {
      this.handleResolve(true)
    },

    handleResolve(state) {
      if (!state && this.isFalseAlert) {
        this.handleUpsertAlert('FalseAlert', 'false')
      } else {
        this.handleUpsertAlert('Resolve', `${state}`)
      }

      if (!state) {
        this.$bvModal.hide('recheck-confirmation')
        this.falseAlarm = false
        if (this.isFalseAlert) this.isFalseAlert = false
      }
      this.isResolved = !state
      this.isQuestioning = !state
    },

    addComment() {
      if (!this.noteForm || this.noteForm.trim() === '') {
        this.$mcToast.error(this.$t('notification.text.giveNoteOrComment'))
        return
      }
      this.handleUpsertAlert('Feedback', this.noteForm)
      this.track('Save Notification Notes', {
        location: 'Detail',
        alert_name: this.alert.alert.descriptionIdn,
      })
      this.noteForm = null
    },

    async handleUpsertAlert(action, data) {
      const input = {
        selectionMode: 'Selection',
        rawAlertId: [this.detailNotification.rawAlertId],
        actionType: action,
        data: data,
      }
      const res = await this.$apollo.mutate({
        mutation: UPSERT_RAW_ALERTS_ACTION,
        variables: { input },
      })

      if (res.data.upsertRawAlertsAction.isSuccessful) {
        this.$mcToast.success(this.$t('global.alert.text.saved'))
        this.$root.$emit('notification-detail-reload')
      } else {
        this.$mcToast.error(this.$t('global.alert.text.failedSaved'))
      }
    },

    openLiveview() {
      const url = `${window.location.protocol}//${window.location.host}/liveview-2/?type=vehicle&vehicleId=${this.alert.vehicleId}`
      window.location.href = url
    },

    openModalConfirmation() {
      if (!this.falseAlertNotes || this.falseAlertNotes.trim() === '') {
        this.$mcToast.error(this.$t('notification.action.fillResolveNote'))
        return
      }
      this.$bvModal.show('false-alert-confirmation')
    },

    openModalRecheck() {
      this.$bvModal.show('recheck-confirmation')
    },

    isFalseAlarm() {
      this.falseAlarm = true
      this.isQuestioning = false
    },
    handleCancelQuestion() {
      this.isQuestioning = true
      this.falseAlarm = false
    },

    selectAlert(alert, timeIndex) {
      this.$emit('selectAlert', alert, timeIndex)
    },
  },
}
</script>
<style lang="scss">
.mc-alert-center-detail-wrapper {
  .mc-detail-alert__new-media-section {
    .mc-image-capture__wrapper {
      height: 390px;
    }
  }
}

.mc-alert-center-detail-wrapper {
  height: 100%;
  .mc-image-capture__wrapper {
    height: 256px;
  }
}

.mc-alert-center-detail__wrapper-row {
  height: calc(100vh - 215px);
  .mc-notification-map-history {
    height: 100%;
  }
}
.mc-alert-center-detail {
  height: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  .mc-alert-center-detail__info-card {
    border: 1px solid $teal-100;
  }
  .mc-alert-center-detail__media-wrapper {
    border: 1px solid $teal-100;
  }
  .mc-alert-center-detail__media-wrapper,
  .mc-alert-center-detail__info-wrapper {
    flex: 1;
  }
  .mc-alert-center-detail__media-wrapper {
    .tabs {
      height: 100%;
    }
  }

  .mc-alert-center-detail__wrapper-info {
    height: 330px;
    overflow: hidden;
    overflow-y: auto;
  }
}
.mc-alert-center-detail__info {
  .card {
    margin-bottom: 0px;
  }
}

.mc-alert-center-detail__alert-data {
  .alert-data__label {
    color: $text-muted;
    display: block;
  }
}

.mc-alert-center-detail__info-row {
  row-gap: 12px;

  .col-lg-6 {
    .mc-alert-center-detail__wrapper-info {
      max-height: calc(100vh - 710px);
      overflow: hidden;
      overflow-y: auto;
    }
  }
}
.mc-alert-center-detail__media {
  .mc-alert-center-detail__info-false-btn {
    position: static;
    margin-top: 10px;
  }
}

.mc-alert-center-detail__media-list {
  border: 1px solid $teal-100;
  border-top: 0;
  max-height: 400px;
  overflow-y: auto;

  .col-md-6 {
    position: relative;
    margin-bottom: 15px;

    &:hover {
      .mc-alert-center-detail__media-list-download {
        opacity: 1;
      }
    }
  }
}

.mc-alert-center-detail_info-false-text {
  white-space: normal;
  word-wrap: break-word;
  max-width: calc(100% - 185px); // Reserves space for buttons
  display: flex;
  align-items: flex-start;
  gap: 4px;
  min-height: 100%;

  i {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    height: 100%;
  }

  strong {
    display: inline-block;
    word-break: break-all;
  }

  @media screen and (max-width: 1200px) {
    max-width: calc(100% - 205px); // Extra space for smaller screens
  }

  @media screen and (max-width: 992px) {
    max-width: calc(100% - 225px);
  }

  @media screen and (max-width: 768px) {
    max-width: calc(100% - 245px);
  }
}

.mc-alert-center-detail__media-list-title {
  font-size: 14px;
  font-weight: 500;
}

.mc-alert-center-detail__media-list-img {
  border-radius: 10px;
  overflow: hidden;
  img {
    width: 100%;
    height: 250px;
    object-fit: cover;
  }
}

.mc-alert-center-detail__media-list-download {
  position: absolute;
  bottom: 15px;
  border-radius: 0 0 10px 10px;
  left: 12px;
  width: calc(100% - 24px);
  box-sizing: border-box;
  background: $teal-600;
  padding: 10px;
  color: $white;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  opacity: 0;
  transition: all 0.3s ease;

  .mc-fa {
    margin-right: 5px;

    &:before {
      color: $white;
    }
  }
}

.mc-alert-center-detail__media-video {
  video {
    width: 100%;
  }
}

.mc-alert-center-detail__info {
  .row {
    display: flex;
    flex-wrap: wrap;
  }

  .col-md-6 {
    display: flex;
    flex-direction: column;
  }

  &-card {
    height: 100%;
    display: flex;
    flex-direction: column;

    .card-body {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }
}

.mc-alert-center-detail__info-card {
  .blue-500 {
    cursor: pointer;
  }

  .align-items-center {
    .alert-error {
      margin-left: 10px;
    }

    .mc-alert__text {
      margin: 0;
      font-weight: bold;
      color: $red;
      font-size: 16px;
    }
  }
}

.mc-alert-center-detail__info-vehicle {
  padding: 8px;
  border: 1px solid $teal-100;
  position: relative;
  border-radius: 8px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  img {
    max-width: 48px;
  }
}

.mc-alert-center-detail__info-location {
  display: flex;
  gap: 0.5rem;
  .mc-fa {
    &:before {
      font-size: 20px;
      color: $red;
    }
  }
}

.mc-alert-center-detail__info-false {
  padding: 10px;
  border: 1px solid $teal-100;
  border-radius: 4px;
  position: relative;
  background-color: $gray;

  .mc-fa {
    &:before {
      color: $red;
    }
  }
}

.mc-alert-center-detail__info-false-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 100%;
}

.mc-alert-center-detail__info-note {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-top: 10px;
  width: 100%;

  .formulate-input {
    flex: 1;
    padding: 0;
    margin-right: 0.5rem;

    textarea {
      height: 38px;
    }
  }

  .__cancel-button .mc-icon:before {
    color: $danger;
  }

  .__accept-button .mc-icon:before {
    color: $success;
  }
}

.mc-alert-center-detail__info-note-btn {
  position: absolute;
  bottom: 5px;
  left: 0;
}

.mc-alert-center-detail__info-comment-title {
  font-size: 12px;
  margin-bottom: 4px;
  padding-bottom: 4px;
  border-bottom: 1px dashed $teal-100;
}

.mc-alert-center-detail__info-logs {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 1rem;
  .user-logs {
    &__wrapper:first-child {
      .user-logs__item:nth-child(2) {
        .mc-fa {
          &:before {
            color: $cyan;
          }
        }
      }
    }
    &__wrapper {
      position: relative;
    }
    &__item {
      position: relative;
      display: flex;
      justify-content: space-between;

      .mc-fa {
        margin-right: 4px;
        vertical-align: middle;
        position: relative;
        z-index: 2;

        &:before {
          font-size: 18px;
          background-color: $white;
          color: $teal-200;
        }
      }

      &:last-child {
        .user-logs-content {
          &::before {
            display: none;
          }
        }
      }
    }
  }
}

.user-logs-content {
  display: flex;
  align-items: top;
  position: relative;
  padding-bottom: 15px;

  &::before {
    content: '';
    position: absolute;
    top: 12px;
    left: 8px;
    width: 0px;
    height: 100%;
    border-left: 1px solid $teal-200;
    z-index: 1;
  }

  span {
    color: $teal-300;

    &.user-logs-user {
      color: $teal-400;
    }
  }
}

.user-logs-time {
  white-space: nowrap;
  color: $teal-400;
}

.mc-alert-center-detail__info-timeline-title {
  font-size: 16px;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px dashed $teal-100;
}

.timeline {
  display: flex;
  flex-direction: column;
  position: relative;
  border: 1px solid $teal-100;
  max-height: 250px;
  overflow-y: auto;

  .timeline__wrapper {
    position: relative;
    padding: 15px;
    padding-left: 45px;
    padding-bottom: 60px;

    &:after {
      content: '';
      position: absolute;
      bottom: 15px;
      left: 19px;
      width: 15px;
      height: 15px;
      background-color: $teal-200;
      border: 2px solid $white;
      outline: 3px solid $teal-200;
      border-radius: 100%;
    }

    &::before {
      content: '';
      position: absolute;
      top: 20px;
      left: 25px;
      width: 0px;
      height: calc(100% - 45px);
      border-left: 1px dotted $teal-200;
    }
  }

  &__item {
    position: relative;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    .icon-outline_arrow-circle-right {
      position: absolute;
      left: -28px;
      font-size: 18px;
      top: 0;
      background-color: $white;
    }

    .description {
      white-space: nowrap;
      position: relative;

      img {
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-right: 3px;
        display: inline-block;
        position: relative;
        top: -2px; // This will shift the icon upward
      }

      &.icon_urgent {
        position: relative;
        img {
          filter: invert(37%) sepia(85%) saturate(3820%) hue-rotate(341deg) brightness(100%)
            contrast(119%); // Red icon
        }
      }

      &.icon_important {
        position: relative;
        img {
          filter: brightness(0) saturate(100%) invert(49%) sepia(46%) saturate(1692%)
            hue-rotate(2deg) brightness(108%) contrast(104%); // Yellow icon
        }
      }

      &.icon_grey {
        position: relative;
        img {
          filter: invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%)
            contrast(100%); // Grey icon
        }
      }
    }
  }

  &__date {
    font-weight: 500;
    font-size: 12px;
    margin-bottom: 10px;
  }

  &__time {
    display: flex;
    align-items: center;
    margin: 0 0 10px 15px;
    font-size: 12px;

    &:hover {
      opacity: 0.8;
      transition: opacity 0.3s ease;
      cursor: pointer;
    }

    span:first-child {
      margin-right: 15px;
      white-space: nowrap;
      min-width: 90px;
    }
  }

  &.timeline-important {
    .description {
      &.icon_important {
        position: relative;
        img {
          filter: invert(37%) sepia(85%) saturate(3820%) hue-rotate(341deg) brightness(100%)
            contrast(119%); // Red icon
        }
      }
    }
  }
}

.mc-alert-center-detail_info-false_icon {
  .mc-icon__red:before {
    color: $red;
  }
  .mc-icon__green:before {
    color: $green;
  }
}
.mc-alert-center-detail_info-false_link {
  a {
    color: $blue-500 !important;
    font-weight: 500;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}

.mc-alert-center-detail__info-note__button-confirm {
  margin: 8px 0px 0px;
  padding: 4px 0px;
}

.mc-alert-center-detail__media-wrapper {
  &.general-driver-behavior {
    padding: 0 !important;
    border-left: 0 !important;
    border-right: 0 !important;
    border-top: 0 !important;
    .tab-content {
      border-left: 1px solid $teal-100;
      border-right: 1px solid $teal-100;
      border-top: 1px solid $teal-100;
      max-height: calc(100% - 37px) !important;
    }
    .nav-tabs {
      border: 0px;
    }
  }
}

.notification-center {
  .mc-alert-center-detail {
    overflow: hidden;
    overflow-y: auto;
    height: calc(100vh - 225px);
  }

  .mc-alert-center-detail__info-row {
    .col-lg-6 {
      width: 100%;
    }
  }
}

@media only screen and (max-height: 800px) {
  .mc-alert-center-detail__wrapper-col:first-child {
    overflow-y: scroll;
    .mc-alert-center-detail__media-wrapper {
      flex: none;
    }
    .mc-alert-center-detail__info-wrapper {
      flex: none;
    }
    .mc-alert-center-detail__media-wrapper {
      .tab-content {
        max-height: 232px !important;
      }
    }
    .mc-alert-center-detail__info-row {
      .col-lg-6 {
        width: 100% !important;
      }
    }
  }
}
@media only screen and (max-width: 1400px) {
  .mc-alert-center-detail__media {
    .mc-alert-center-detail__info {
      .col-md-6 {
        width: 100%;
      }
    }
  }
}
</style>
